import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { Provider } from 'react-redux';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import store from './store/index';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import SharedProvider from '@common/store/SharedProvider';
import mapStateToShared from 'store/shared/map-state-to-shared';
import SharedActionsMapper from 'store/shared/map-actions-to-shared';

const muiCache = createCache({
  key: 'mui',
  prepend: true,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <CacheProvider value={muiCache}>
    <Provider store={store}>
      <SharedProvider
        store={{
          getState: () => mapStateToShared(store.getState()),
          actions: SharedActionsMapper,
          dispatch: store.dispatch,
          subscribe: store.subscribe,
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SharedProvider>
    </Provider>
  </CacheProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// To send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
